
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';

import { DashboardPage } from '../pages/DashboardPage';
import { RequireAuth } from '../components/layouts/RequireAuth';
import { AdminLayout } from '../components/layout/AdminLayout';
import { MaintenanceGuard } from '../features/maintenance';

import { AnalyticsPage, PlatformValuePage, ChannelsPage } from '../pages/base_pages';
import { SettingsPage } from '../pages/SettingsPage';
import { CustomersPage } from '../pages/customers/CustomersPage';
import { CustomerDetailsPage } from '../pages/customers/CustomerDetailsPage';
import { CustomerInvoicesPage } from '../pages/customers/CustomerInvoicesPage';
import { OrdersPage } from '../pages/payment_pages';
import { OrderDetailsPage } from '../pages/payment_pages/OrderDetailsPage';
import { ProductsPage } from '../pages/payment_pages/ProductsPage';
import { ProductDetailsPage } from '../pages/payment_pages/ProductDetailsPage';
import { DiscountsPage } from '../pages/payment_pages/DiscountsPage';
import { DiscountDetailsPage } from '../pages/payment_pages/DiscountDetailsPage';
import { FeatureRegistryPage } from '../pages/payment_pages/FeatureRegistryPage';
import { AuditTrailPage, SupportPage } from '../pages/template_pages';
import LogsPage from '../pages/logs/LogsPage';
import { TemplateStudioPage } from '../pages/TemplateStudioPage';
import { AIUsagePage } from '../pages/AIUsagePage';
import { CostsPage } from '../pages/CostsPage';
import { EmailManagerPage, EmailFlowDetailPage } from '../pages/email';
import { DemoRequestsPage } from '../pages/DemoRequestsPage';

import '../styles/globals.css';

const App = () => {
    return (
        <MaintenanceGuard>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />


                    <Route element={<RequireAuth />}>
                        <Route element={<AdminLayout />}>
                            <Route path="/" element={<DashboardPage />} />
                            <Route path="/customers" element={<CustomersPage />} />
                            <Route path="/customers/:id" element={<CustomerDetailsPage />} />
                            <Route path="/customers/:id/invoices" element={<CustomerInvoicesPage />} />

                            {/* Payments Routes */}
                            <Route path="/payments/orders" element={<OrdersPage />} />
                            <Route path="/payments/orders/:id" element={<OrderDetailsPage />} />
                            <Route path="/payments/products" element={<ProductsPage />} />
                            <Route path="/payments/products/:id" element={<ProductDetailsPage />} />
                            <Route path="/payments/discounts" element={<DiscountsPage />} />
                            <Route path="/payments/discounts/new" element={<DiscountDetailsPage />} />
                            <Route path="/payments/discounts/:id" element={<DiscountDetailsPage />} />
                            <Route path="/payments/features" element={<FeatureRegistryPage />} />

                            <Route path="/analytics" element={<AnalyticsPage />} />
                            <Route path="/platform-value" element={<PlatformValuePage />} />
                            <Route path="/channels" element={<ChannelsPage />} />
                            <Route path="/ai-usage" element={<AIUsagePage />} />
                            <Route path="/costs" element={<CostsPage />} />

                            {/* Email Manager Routes */}
                            <Route path="/email" element={<EmailManagerPage />} />
                            <Route path="/email/flows/:id" element={<EmailFlowDetailPage />} />

                            {/* Demo booking requests */}
                            <Route path="/demo-requests" element={<DemoRequestsPage />} />

                            {/* Template Studio Routes */}
                            <Route path="/templates" element={<TemplateStudioPage />} />
                            <Route path="/templates/audit" element={<AuditTrailPage />} />
                            <Route path="/templates/support" element={<SupportPage />} />

                            {/* Logs Routes */}
                            <Route path="/logs" element={<LogsPage />} />

                            <Route path="/settings" element={<SettingsPage />} />

                        </Route>
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </MaintenanceGuard>
    );
};

export default App;

